import React, { useState } from 'react';
import styles from './OptionList.module.scss';
import cx from 'classnames';
import { getIconBaseUrl } from '../../utils/assets';
export var OptionSize;
(function (OptionSize) {
    OptionSize["SMALL_SIZE"] = "small";
    OptionSize["MEDIUM_SIZE"] = "medium";
})(OptionSize || (OptionSize = {}));
const placeholderImage = {
    src: getIconBaseUrl('h-placeholder.svg'),
    height: '105',
};
const Option = ({ label, subLabel, value, name, disabled = false, inputType = 'radio', checked, image, optionSize = OptionSize.SMALL_SIZE, onChange, imageLayout = 'large', hideInput = false, }) => {
    const id = label.replace(/\s+/g, '');
    return (<label htmlFor={id} key={label} className={cx(styles.optionContainer, {
            [styles.optionCardLayout]: (image === null || image === void 0 ? void 0 : image.src) && imageLayout === 'large',
            [styles.optionWithImage]: (image === null || image === void 0 ? void 0 : image.src) && imageLayout === 'small',
        })}>
      <span>
        {(image === null || image === void 0 ? void 0 : image.src) ? <img {...image} alt={label}/> : null}
        <span className={cx(styles.option, {
            [styles.optionCheckBox]: inputType === 'checkbox',
            [styles.hideInput]: hideInput,
            [styles.optionMedium]: optionSize === OptionSize.MEDIUM_SIZE,
        })}>
          <input type={inputType} value={value} name={name} id={id} disabled={disabled} checked={checked} onChange={onChange}/>
          <span className={styles.label}>{label}</span>
          {subLabel && <span className={styles.subLabel}>{subLabel}</span>}
        </span>
      </span>
    </label>);
};
const OptionList = ({ options, groupName, onChange, allowMultiSelect = false, defaultValue = [], optionSize = OptionSize.SMALL_SIZE, showCardLayout, }) => {
    const defaultSelected = Array.isArray(defaultValue) ? defaultValue : [defaultValue];
    const [selectedValuesState, setSelectedValuesState] = useState(defaultSelected);
    const smallImageLayout = options.length > 6;
    const handleInputChange = (event) => {
        const { value: inputValue, checked } = event.target;
        const updatedState = checked
            ? [...(allowMultiSelect ? selectedValuesState : []), inputValue]
            : selectedValuesState.filter((value) => value !== inputValue);
        setSelectedValuesState(updatedState);
        const value = allowMultiSelect ? updatedState : updatedState[0];
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    return (<fieldset className={cx(styles.optionList, {
            [styles.cardList]: showCardLayout && !smallImageLayout,
            [styles.smallImageCards]: smallImageLayout,
        })}>
      {options.map(({ label, subLabel, value, disabled, image, hideInput }) => (<Option key={label} label={label} subLabel={subLabel} value={value} name={groupName} disabled={disabled} inputType={allowMultiSelect ? 'checkbox' : 'radio'} image={showCardLayout ? image || placeholderImage : undefined} optionSize={optionSize} checked={selectedValuesState.includes(value)} onChange={handleInputChange} imageLayout={smallImageLayout ? 'small' : 'large'} hideInput={hideInput}/>))}
    </fieldset>);
};
export default OptionList;
